import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { createJpdExperience } from '../../utils/experience/main.tsx';

export const updateViewDescription = createJpdExperience(
	new UFOExperience('jpd.header-view.update-view-description', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const viewGroupBy = createJpdExperience(
	new UFOExperience('jpd.header-view.view-group-by', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const viewSort = createJpdExperience(
	new UFOExperience('jpd.header-view.view-sort', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const viewFilter = createJpdExperience(
	new UFOExperience('jpd.header-view.view-filter', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);
